import {
  InfoModule,
  createInfoServices
} from "./chunk-O2VHLUZY.mjs";
import "./chunk-U3TRWOCV.mjs";
export {
  InfoModule,
  createInfoServices
};
